import { DateTime } from 'luxon'

const timespans = [
  {
    value: 'thisMonth',
    localeString: 'dashboard.timespans.thisMonth',
    grammarString: 'dashboard.timespans.thisMonth_grammar'
  },
  {
    value: 'lastMonth',
    localeString: 'dashboard.timespans.lastMonth',
    grammarString: 'dashboard.timespans.lastMonth_grammar'
  },
  {
    value: 'thisYear',
    localeString: 'dashboard.timespans.thisYear',
    grammarString: 'dashboard.timespans.thisYear_grammar'
  },
  {
    value: 'lastYear',
    localeString: 'dashboard.timespans.lastYear',
    grammarString: 'dashboard.timespans.lastYear_grammar'
  }
]

export default {
  computed: {
    timespans () {
      return timespans
    }
  },
  methods: {
    formatDate (date) {
      let input = DateTime.fromISO(date)
      return date && input.isValid
        ? input
          .setLocale(this.getLocale(this.$i18n.locale))
          .toLocaleString(DateTime.DATETIME_SHORT)
        : ''
    },
    formatDateShort (date) {
      let input = DateTime.fromISO(date)
      return date && input.isValid
        ? input
          .setLocale(this.getLocale(this.$i18n.locale))
          .toLocaleString(DateTime.DATE_SHORT)
        : ''
    },
    dateTime () {
      return DateTime
    },
    currentDate () {
      return DateTime.local()
    },
    getDateString(scope, date) {
      if (scope === 'day') {
        return date.toLocaleString()
      }
      if (scope === 'month') {
        return date.monthLong
      }
    },
    startOfLastMonth() {
      return DateTime.local()
        .minus({ month: 1 })
        .startOf('month')
        .toISO()
    },
    endOfLastMonth() {
      return DateTime.local()
        .minus({ month: 1 })
        .endOf('month')
        .toISO()
    },
    startOfLastYear() {
      return DateTime.local()
        .minus({ years: 1 })
        .startOf('year')
        .toISO()
    },
    endOfLastYear() {
      return DateTime.local()
      .minus({ years: 1 })
      .endOf('year')
      .toISO()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dates.js